import axios from "axios";

// Plain axios instance for fetching public, unauthenticated static JSON
// directly from the CDN (personalization config, etc.) — no baseURL, no
// auth/encryption interceptors, since these aren't backend API calls and
// the CDN doesn't speak the backend's encrypted request/response format.
const axiosInstanceCdn = axios.create({
  timeout: 5000,
});

export default axiosInstanceCdn;
